module.exports = __webpack_public_path__ + "img/active_detractor.73d0d584.png";